import PropTypes from "prop-types";

import Icon from "../icon/Icon";
import LoadingSvg2 from "../loadingSvg/LoadingSvg2";
import useStudentImages from "../../hooks/useStudentImages";

import "../../styles/HistoricalRosterTable.scss";

const StudentRosterTable = ({ students, schoolYearKey, token, loadImages, renderActions }) => {
    const { images: studentImages, loading } = useStudentImages(
        loadImages ? students : [],
        loadImages ? schoolYearKey : null,
        loadImages ? token : null
    );

    const sortedStudents = [...students].sort((a, b) => {
        const ln = a.lastName.localeCompare(b.lastName);
        return ln !== 0 ? ln : a.firstName.localeCompare(b.firstName);
    });

    return (
        <div className="epr-students-table">
            {loading ? (
                <LoadingSvg2 />
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Student</th>
                            {renderActions && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {sortedStudents.length > 0 &&
                            sortedStudents.map((student) => {
                                const imageUrl = studentImages[student.studentNumber];

                                return (
                                    <tr key={student.key ?? student.studentNumber}>
                                        <td>
                                            {imageUrl ? (
                                                <img
                                                    src={imageUrl}
                                                    alt={`${student.firstName} ${student.lastName}`}
                                                    style={{ width: "45px", height: "60px", borderRadius: "5%" }}
                                                />
                                            ) : (
                                                <Icon
                                                    iconName="NO_STUDENT_IMAGE"
                                                    fill="#19608F"
                                                    height={60}
                                                    width={45}
                                                />
                                            )}
                                            <span style={{ marginLeft: "8px" }}>
                                                {student.lastName}, {student.firstName}
                                            </span>
                                        </td>

                                        {renderActions && (
                                            <td>
                                                <div
                                                    className="historical-student-actions"
                                                    style={{ display: "flex", justifyContent: "flex-end" }}
                                                >
                                                    {renderActions(student)}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        {sortedStudents.length === 0 && (
                            <tr>
                                <td colSpan={renderActions ? 2 : 1} style={{ textAlign: "center" }}>
                                    Your Report Card does not have students rostered. Please go to Manage Roster to
                                    import your IC homeroom section.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

StudentRosterTable.propTypes = {
    students: PropTypes.array.isRequired,
    schoolYearKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    token: PropTypes.string,
    loadImages: PropTypes.bool,
    renderActions: PropTypes.func
};

export default StudentRosterTable;
